import React, { useEffect, useState } from 'react'
import { useRequests } from '../../requests/useRequests'
import { PageBanner } from '../Banners/PageBanner'
import AppNavBar from '../Header/AppNavBar'

interface ProductStat {
  productId: number
  productName: string
  brandName: string
  downloadCount: number
  category: string
  code: string
}

interface UserProductStat {
  userId: number
  username: string
  productId: number
  productName: string
  brandName: string
  downloadCount: number
  category: string
  code: string
}

interface BrandVisitStat {
  brandId: number
  brandName: string
  visitCount: number
}

const ProductStats: React.FC = () => {
  const requests = useRequests()
  const [productStats, setProductStats] = useState<ProductStat[]>([])
  const [userProductStats, setUserProductStats] = useState<UserProductStat[]>([])
  const [brandVisitStats, setBrandVisitStats] = useState<BrandVisitStat[]>([])
  const [loading, setLoading] = useState(true)
  const [brandNameFilter, setBrandNameFilter] = useState('')

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [productStatsResponse, userProductStatsResponse, brandVisitStatsResponse] = await Promise.all([
          requests.getProductDownloadStats(brandNameFilter),
          requests.getUserProductDownloadStats(brandNameFilter),
          requests.getBrandVisitStats(brandNameFilter)
        ])

        setProductStats(productStatsResponse.data)
        setUserProductStats(userProductStatsResponse.data)
        setBrandVisitStats(brandVisitStatsResponse.data)
      } catch (error) {
        console.error('Błąd podczas pobierania statystyk:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [brandNameFilter])

  const handleBrandNameFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBrandNameFilter(e.target.value)
  }

  if (loading) {
    return (
      <div className='container my-5'>
        <div className='text-center py-5'>
          <div className='spinner-border text-primary' role='status'>
            <span className='sr-only'>Ładowanie...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <AppNavBar
        centerText='Statystyki pobrań produktów'
        rightIcons={[]}
      />
      <section className='product-stats pt-60 pb-60'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 mb-4'>
              <div className='filter-section'>
                <div className='form-group'>
                  <label htmlFor='brandNameFilter'>Filtruj po nazwie marki:</label>
                  <input
                    type='text'
                    className='form-control'
                    id='brandNameFilter'
                    value={brandNameFilter}
                    onChange={handleBrandNameFilterChange}
                    placeholder='Wpisz nazwę marki...'
                  />
                </div>
              </div>
            </div>

            <div className='col-12 mb-5'>
              <h2 className='section-title'>Statystyki pobrań produktów</h2>
              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr>
                      <th>Produkt</th>
                      <th>Kod</th>
                      <th>Kategoria</th>
                      <th>Marka</th>
                      <th>Liczba pobrań</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productStats.map((stat) => (
                      <tr key={stat.productId}>
                        <td>{stat.productName}</td>
                        <td>{stat.code || '-'}</td>
                        <td>{stat.category || '-'}</td>
                        <td>{stat.brandName}</td>
                        <td>{stat.downloadCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='col-12 mb-5'>
              <h2 className='section-title'>Statystyki pobrań produktów przez użytkowników</h2>
              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr>
                      <th>Użytkownik</th>
                      <th>Produkt</th>
                      <th>Kod</th>
                      <th>Kategoria</th>
                      <th>Marka</th>
                      <th>Liczba pobrań</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userProductStats.map((stat, index) => (
                      <tr key={`${stat.userId}-${stat.productId}-${index}`}>
                        <td>{stat.username}</td>
                        <td>{stat.productName}</td>
                        <td>{stat.code || '-'}</td>
                        <td>{stat.category || '-'}</td>
                        <td>{stat.brandName}</td>
                        <td>{stat.downloadCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className='col-12'>
              <h2 className='section-title'>Statystyki odwiedzin marek</h2>
              <div className='table-responsive'>
                <table className='table table-striped'>
                  <thead>
                    <tr>
                      <th>Marka</th>
                      <th>Liczba odwiedzin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {brandVisitStats.map((stat) => (
                      <tr key={stat.brandId}>
                        <td>{stat.brandName}</td>
                        <td>{stat.visitCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProductStats
